// extracted by mini-css-extract-plugin
module.exports = {"explorationTask":"TaskWrapper_explorationTask__1hsu-","offerCount":"TaskWrapper_offerCount__2gX7u"};